import { useState, useEffect } from "react";
import { Fab, Tooltip, Zoom, useMediaQuery, useTheme } from "@mui/material";
import FeedbackIcon from "@mui/icons-material/Feedback";
import FeedbackDialog from "./FeedbackDialog";

const StickyFeedbackButton = () => {
  const [open, setOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Hide button when scrolling to avoid interference with footer or other elements
  useEffect(() => {
    let scrollTimeout;
    const handleScroll = () => {
      setIsVisible(false);
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        setIsVisible(true);
      }, 150);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Zoom in={isVisible} timeout={300}>
        <Tooltip
          title="Send Feedback"
          placement="left"
          arrow
          TransitionProps={{ timeout: 300 }}
        >
          <Fab
            color="primary"
            aria-label="feedback"
            onClick={handleOpen}
            sx={{
              position: "fixed",
              // Smart positioning based on screen size
              bottom: isMobile ? 16 : 24,
              right: isMobile ? 16 : 24,
              zIndex: 999, // Below dialogs (1300) but above most content
              width: isMobile ? 48 : 56,
              height: isMobile ? 48 : 56,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.25)",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              "&:hover": {
                transform: "scale(1.1) rotate(5deg)",
                boxShadow: "0 6px 28px rgba(0, 0, 0, 0.35)",
                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
              },
              "&:active": {
                transform: "scale(0.95)",
              },
              // Add breathing animation
              animation: "breathe 3s ease-in-out infinite",
              "@keyframes breathe": {
                "0%, 100%": {
                  transform: "scale(1)",
                },
                "50%": {
                  transform: "scale(1.05)",
                },
              },
            }}
          >
            <FeedbackIcon
              sx={{
                fontSize: isMobile ? 24 : 28,
                color: "white",
                transition: "transform 0.3s ease",
              }}
            />
          </Fab>
        </Tooltip>
      </Zoom>

      <FeedbackDialog open={open} onClose={handleClose} />
    </>
  );
};

export default StickyFeedbackButton;
